import React from 'react';

/**
 * DefaultPage component shown when no path is provided in the URL.
 * Explains what mythos365 means.
 */
const DefaultPage: React.FC = () => {
  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground px-4">
      <section className="max-w-xl w-full text-center p-8 bg-background-paper rounded-lg shadow-md">
        <h1 className="text-4xl font-bold mb-4">Welcome to Mythos365</h1>
        <p className="text-lg mb-6">
          <strong>mythos365</strong> is a platform designed to help you manage, book, and discover services all year round. The name "mythos" comes from the Greek word for "story" or "legend," and <strong>365</strong> represents every day of the year. Together, <span className="font-semibold">mythos365</span> means "your story, every day"—empowering you to create, share, and manage your service experiences seamlessly.
        </p>
      </section>
    </main>
  );
};

export default DefaultPage;
